import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import PropTypes from 'prop-types';
import Typography from 'Components/UI/Typography';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import { useMeetingContext } from 'Context/MeetingContext';
import fr from 'facet-rest';
import { Accomplishments } from 'Components/ComponentLibrary/Components/Uncategorized/Accomplishments';
import Notes from '../Notes';

const styles = (theme) => ({
  border: {
    background: theme.palette.facet.lightGray,
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
    marginBottom: theme.spacing(2),
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
  },
  content: {
    background: theme.palette.common.white,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1),
    // margin: 10,
  },
  pageHeader: {
    color: theme.palette.facet.primaryBlueMuted,
    margin: theme.spacing(3),
  },
  componentHeader: {
    textTransform: 'uppercase',
    fontWeight: theme.typography.fontWeightBold,
    marginLeft: theme.spacing(2),
  },
  subComponentHeader: {
    marginLeft: theme.spacing(1),
  },
  footnote: {
    color: theme.palette.facet.primaryBlueMuted,
    fontWeight: theme.typography.fontWeightBold,
    textAlign: 'center',
  },
  swag: {
    margin: theme.spacing(1),
    paddingTop: theme.spacing(1),
  },
  flex: {
    display: 'flex',
  },
});


function AccomplishmentsTab({ classes }) {
  const { rootNodeProps } = useEventTrackingLogEvent({
    nodeName: 'Client Experience Tab',
    isPageView: true,
  });
  const { householdResource } = useSimpleHousehold();
  const { meetingResource } = useMeetingContext();
  return (
    <div {...rootNodeProps} className={classes.root}>
      <Typography
        variant="h2"
        className={classes.pageHeader}
      >
        Client Accomplishments
      </Typography>
      <div className={classes.border}>
        <Accomplishments
          isFutureAccomplishment={false}
          bestNextStepLink={householdResource.relationship(fr.relationships.accomplishmentBestNextSteps.name).link('related')}
          accomplishmentsLink={householdResource.relationship(fr.relationships.pastAccomplishments.name).link('related')}
          title="ACCOMPLISHMENTS-"
          text="What did we accomplish with this client in the past year?"
        />
        <Typography
          variant="h5"
          className={classes.swag}
        >
          Did you know that we send Facet swag to clients for certain life events? Click <a href="https://docs.google.com/forms/d/e/1FAIpQLScTcifTmhgAkBuD5I_Vldss8ywYvY0itnX83ujsmPU5XLiFBQ/viewform" target="_blank" rel="noopener noreferrer">here</a> to provide us with some details and we&apos;ll take it from there.
        </Typography>
      </div>
      <div className={classes.border}>
        <Accomplishments
          isFutureAccomplishment
          bestNextStepLink={householdResource.relationship(fr.relationships.nextBestNextSteps.name).link('related')}
          accomplishmentsLink={householdResource.relationship(fr.relationships.futureAccomplishments.name).link('related')}
          title="THE YEAR AHEAD-"
          text="What do we plan to accomplish in the year ahead?"
        />
      </div>
      <div className={classes.border}>
        <div className={classes.content}>
          <Typography
            variant="h4"
            className={classes.componentHeader}
          >
            Client Experience Note
          </Typography>
          <Notes
            classes={classes}
            resource={meetingResource}
          />
        </div>
      </div>
      <Typography
        variant="h3"
        className={classes.footnote}
      >
        Don&apos;t forget to take a little victory lap in #dreamsmadepossible
      </Typography>
    </div>
  );
}

AccomplishmentsTab.defaultProps = {
  classes: {
    root: '',
  },
};

AccomplishmentsTab.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(styles)(AccomplishmentsTab);
